import styled from "styled-components";

export const Container = styled.div``;

export const LessonInfoboxWrapper = styled.div`
  padding-top: 80px;
`;
